import '../styles/UpdatesSection.css';

// Placeholder content — swap in real posts/partners once you have them.
const UPDATES = [
  {
    date: '01.01.2026',
    tags: 'Network, Foundation',
    title: 'Introducing the Dev Mainnet Foundation and DMT token',
    icon: 'mark',
  },
  {
    date: '01.08.2026',
    tags: 'Network',
    title: 'What is the Dev Mainnet Network?',
    icon: 'dots',
  },
  {
    date: '01.15.2026',
    tags: 'Network, Foundation',
    title: 'The new standard for onchain wallet certification',
    icon: 'ring',
  },
];

export default function UpdatesSection() {
  return (
    <section className="updates-section">
      <div className="updates-grid">
        {UPDATES.map((item) => (
          <div className="update-card" key={item.title}>
            <div className="update-card-top">
              <CardIcon type={item.icon} />
            </div>
            <div className="update-card-bottom">
              <div className="update-meta">
                <span>{item.date}</span>
                <span className="update-tags">{item.tags}</span>
              </div>
              <h3 className="update-title">{item.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function CardIcon({ type }) {
  if (type === 'dots') {
    return (
      <svg width="90" height="90" viewBox="0 0 90 90" fill="none" aria-hidden="true">
        <rect x="30" y="30" width="30" height="30" stroke="#8a8c92" strokeWidth="1.5" />
        <circle cx="30" cy="30" r="16" fill="#8a8c92" />
        <circle cx="60" cy="30" r="16" fill="#8a8c92" />
        <circle cx="30" cy="60" r="16" fill="#8a8c92" />
        <circle cx="60" cy="60" r="16" fill="#8a8c92" />
      </svg>
    );
  }

  if (type === 'ring') {
    return (
      <svg width="90" height="90" viewBox="0 0 90 90" fill="none" aria-hidden="true">
        <circle cx="45" cy="45" r="40" stroke="#c9a24a" strokeWidth="1.5" />
        <path
          d="M22 48a23 23 0 0 1 46 0"
          stroke="#c9a24a"
          strokeWidth="6"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M18 58l10 10 10-10 10 10 10-10"
          stroke="#c9a24a"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
    );
  }

  // default: brand mark
  return (
    <svg
      width="176"
      height="46"
      viewBox="0 0 320 84"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M8 46l16 22 16-22 16 22 16-22"
        stroke="#ffffff"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <text
        x="86"
        y="55"
        fill="#ffffff"
        fontSize="30"
        fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        fontWeight="600"
      >
        Dev Mainnet
      </text>
    </svg>
  );
}